function DoubleCheck({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.9738 2.02875L12.9163 0.971252L8.16125 5.72625L9.21875 6.78375L13.9738 2.02875ZM17.1537 0.971252L9.21875 8.90625L6.08375 5.77875L5.02625 6.83625L9.21875 11.0288L18.2188 2.02875L17.1537 0.971252ZM0.78125 6.83625L4.97375 11.0288L6.03125 9.97125L1.84625 5.77875L0.78125 6.83625Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default DoubleCheck;
